import Controller from '../abstracts/Controller';
import 'scss-templates/t-storelocator-detail.scss';

export default class StoreLocatorDetailController extends Controller {

  static get COMPONENTS() {
    return [
      'StoreLocatorDetailComponent',
      'PdpImagesComponent',
      // 'PrintComponent',
      // 'DatePickerComponent',
      'BookingAptComponent',
      'VideoComponent',
      'HeroComponent',
      'InfoBoxCarouselComponent',
      'EditorialProductsSliderComponent',
      'DoubleLaunchComponent'
    ];
  }


  init() {
    super.init();
  }

}
